import React, { useState } from "react";
import { Image, OverlayTrigger, Popover } from "react-bootstrap";
import { useEnvironmentalClaimsQuery } from "../../../../../hooks/useEnvironmentalClaimsQuery";
import { useAppContext } from "../../../../../hooks/useAppContext";
import { useScreenSizeDetector } from "../../../../../hooks/useScreenSizeDetector";


export const EnvironmentalLogo = () => {
    const { catalogId } = useAppContext();
    const { model: { isConscious } } = useEnvironmentalClaimsQuery();
    const [showPopover, setShowPopover] = useState(false);
    const { isLargeScreenSize } = useScreenSizeDetector();

    const handleMouseEnter = () => {
        setShowPopover(true);
    };

    const handleMouseLeave = () => {
        setShowPopover(false);
    };

    const popover = (
        <Popover id="greenprint-popover">
            <Popover.Body>
                Our Greenprint icon represents products that support a combination of environmental and social initiatives.
            </Popover.Body>
        </Popover>
    );

    if (catalogId !== 1 || !isConscious) return <></>;

    return (
        <div className="p-3 text-center">
            <OverlayTrigger
                trigger="hover"
                placement={`${isLargeScreenSize ? 'right' : 'auto'}`}
                overlay={popover}
                show={showPopover}
            >
                <div
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <Image
                        className="img-fluid"
                        height={82}
                        width={240}
                        src="https://static.commerceplatform.services/content/img/greenprint-product-logo.png"
                        alt="Greenprint Product"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </OverlayTrigger>
        </div>
    );
};
